<template>
  <div class="container row">
    <div class="main row">
      <div class="nav row">
        <div class="nav-item">查询历史</div>
        <el-button class="nav-item clear-history gray-button" @click="clearHistory">清空历史</el-button>
      </div>
      <div class="table-container">
        <el-table :data="tableData" class="left-bottom-table" v-loading="tableLoading">
          <el-table-column prop="keyword" label="公司名称" show-overflow-tooltip width="260">
            <template slot-scope="scope">
              <div class="overflow-auto"><div>{{scope.row.company_name}}</div></div>
            </template>
          </el-table-column>

          <el-table-column prop="keyword" label="关键字" show-overflow-tooltip width="260">
            <template slot-scope="scope">
              <div class="overflow-auto"><div>{{scope.row.keyword}}</div></div>
            </template>
          </el-table-column>

          <el-table-column prop="date_range" label="日期" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="overflow-auto"><div>{{scope.row.date_range}}</div></div>
            </template>
          </el-table-column>

          <el-table-column prop="filter" label="过滤条件" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="overflow-auto"><div>{{scope.row.filter}}</div></div>
            </template>
          </el-table-column>

          <el-table-column prop="search_time" label="搜索时间" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="overflow-auto"><div>{{scope.row['search_time']}}</div></div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <div class="row">
                <div class="operation-look-over" @click="lookOver(scope.row)">
                  查看
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="bottom-container row">
        <el-pagination
          class="left-bottom-pagination border-pagination"
          @current-change="handleCurrentPageChange"
          :hide-on-single-page="total<=pageSize"
          :current-page="pageNum"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
        <div class="page-size-selector row">
          <el-dropdown @command="handlePageSizeChange" class="page-size-dropdown">
            <span class="el-dropdown-link">
              {{pageSize}}条/页<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(size, index) in [10,20,30,50,100]" :key="index" :command="size">{{size}}条/页</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/rest/questionQuery';

export default {
  data() {
    return {
      tableLoading: false,
      tableData: null,
      pageSize: 20,
      total: 0,
      pageNum: 1,
      sendMessage: null
    };
  },
  destroyed() {
    if (this.sendMessage) {
      eventBus.$emit('lookover', this.sendMessage);
    }
  },
  methods: {
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.refresh();
    },
    handleCurrentPageChange(e) {
      this.pageNum = e;
      this.refresh();
    },
    lookOver(row) {
      this.sendMessage = row.question_json;
      this.$router.push('/');
    },
    async clearHistory() {
      await api.clearHistory();
      this.refresh();
    },
    async getHistory() {
      const res = await api.getHistory(this.pageNum, this.pageSize);
      if (res) {
        this.total = res.total;
        this.tableData = res.items;
      }
    },
    refresh() {
      this.getHistory();
    }
  },
  mounted() {
    this.getHistory();
  }
};
</script>

<style lang="scss" scoped>
  .container {
    justify-content: center;
    width: 100vw;
    height: calc(100vh - 124px);
    overflow: hidden;
    .main {
      margin-top: 24px;
      flex-direction: column;
      align-items: center;
      width: 1200px;
      min-width: 1200px;
      background-color: #fff;
      overflow: hidden;
      .nav {
        justify-content: space-between;
        align-items: center;
        box-shadow: inset 0px -1px 0px 0px #f2f3f7;
        width: 100%;
        height: 48px;
        flex-shrink: 0;
        .nav-item {
          margin: 0 32px;
        }
      }
      .table-container {
        width: 1136px;
        overflow: auto;
        .el-table {
          .operation-look-over {
            color: #2b76ff;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #004ce6;
            }
            &:active {
              color: #0044cc;
            }
          }
        }
      }
      .bottom-container {
        margin: 32px 0;
        justify-content: space-between;
        align-items: center;
        width: 1136px;
        .page-size-selector {
          align-items: center;
          border: 1px solid #e5e6ee;
          border-radius: 2px;
          padding: 3px 12px;
          font-size: 12px;
        }
      }
    }
  }
</style>
